import { EMortgageRateHikeBannerStatus } from '../../types/mortgageRateHikeBanner';
import { IApplicationState } from '../../types/redux';

export function selectIsMortgageRateHikeBannerAvailable(state: IApplicationState): boolean {
  return state.mortgageRateHikeBannerStatus === EMortgageRateHikeBannerStatus.Available;
}
